import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import axios from "axios";
import 'quill/dist/quill.snow.css'
import { useNavigate } from "react-router-dom";
import GeneralRequestHelper from '../../../../../Helpers/GeneralRequestHelper';
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom';

// Her bir eğitim verisi için bağımsız çalışan form bileşeni
const SingleEducationalForm = ({ educational, courses, allsubjects, userId, userToken, t, toPlainOptionLabel }) => {
    const [localCourseId, setLocalCourseId] = useState(String(educational.courseId || ""));
    const [localSubjectId, setLocalSubjectId] = useState(String(educational.subjectId || ""));
    const [localSubjects, setLocalSubjects] = useState([]);
    const [localSubjectLoading, setLocalSubjectLoading] = useState(false);

    const getAuthHeaders = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + userToken
    });

    const fetchLocalSubjects = async (courseId) => {
        if (!courseId) {
            setLocalSubjects([]);
            return;
        }
        try {
            setLocalSubjectLoading(true);
            const res = await axios({
                method: 'GET',
                url: "https://api.heryerdeingilizce.com/api/admin/SubjectManager/GetListByCourse",
                headers: getAuthHeaders(),
                params: { id: courseId }
            });
            if (res.status === 200 && res.data['success']) {
                setLocalSubjects((res.data?.data || []).filter((item) => item?.isActive));
            } else {
                setLocalSubjects([]);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLocalSubjectLoading(false);
        }
    };

    // İlk yüklendiğinde mevcut kursun konularını getir
    useEffect(() => {
        if (localCourseId) {
            fetchLocalSubjects(localCourseId);
        }
    }, []);

    const handleCourseChange = async (e) => {
        const courseId = e.target.value;
        setLocalCourseId(courseId);
        setLocalSubjectId("");
        await fetchLocalSubjects(courseId);
    };

    const handleLocalSubmit = async (e) => {
        e.preventDefault();

        let CourseId = 0;
        let SubjectId = 0;

        courses.forEach((item) => {
            if (item['id'] === parseInt(localCourseId)) {
                CourseId = item.sortId;
            }
        });

        allsubjects.forEach((item) => {
            if (item['id'] === parseInt(localSubjectId)) {
                SubjectId = item['sortId'];
            }
        });

        try {
            let url = "https://api.heryerdeingilizce.com/api/admin/User/UpdateEducational";
            await axios({
                method: 'PUT',
                url: url,
                data: {
                    userId: userId,
                    courseId: parseInt(CourseId),
                    subjectId: parseInt(SubjectId),
                    contentId: 1
                },
                headers: getAuthHeaders()
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başarılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    } else {
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                } else {
                    Swal.fire({
                        title: "Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.",
                        icon: "error",
                        confirmButtonText: "Tamam"
                    });
                }
            });
        } catch (err) {
            Swal.fire({
                title: err.message,
                icon: "error",
                confirmButtonText: "Tamam"
            });
        }
    };

    return (
        <form onSubmit={handleLocalSubmit} className="border p-4 mb-4 rounded bg-light shadow-sm">
            <h6 className="text-primary border-bottom pb-2 mb-3">Eğitim Kayıt ID: {educational.id}</h6>

            <div className="mb-3">
                <label className="form-label">{t("selectCourse")}</label>
                <select
                    className="form-select"
                    onChange={handleCourseChange}
                    value={localCourseId}
                >
                    <option value="">{t("selectCourse")}</option>
                    {courses ? (
                        courses.map((dt) => (
                            <option key={dt.id} value={dt.id}>
                                {toPlainOptionLabel(`${dt.courseName} - ${dt.courseDesc}`)}
                            </option>
                        ))
                    ) : (
                        <option value="">{t("reloadWarning")}</option>
                    )}
                </select>
            </div>

            <div className="mb-3">
                <label className="form-label">{t("selectSubject")}</label>
                <select
                    className="form-select"
                    onChange={(e) => setLocalSubjectId(e.target.value)}
                    value={localSubjectId}
                    disabled={!localCourseId || localSubjectLoading}
                >
                    <option value="">{t("selectSubject")}</option>
                    {localSubjects ? (
                        localSubjects.map((dt) => (
                            <option key={dt.id} value={dt.id}>
                                {toPlainOptionLabel(`${dt.subjectName} - ${dt.subjectDesc}`)}
                            </option>
                        ))
                    ) : (
                        <option value="">{t("reloadWarning")}</option>
                    )}
                </select>
            </div>

            <div className='d-flex justify-content-end'>
                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!localCourseId || !localSubjectId}
                >
                    {t("update")}
                </button>
            </div>
        </form>
    );
};

// Ana Bileşen
export const AdminEditUserEducational = () => {
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [subjectLoading, setSubjectLoading] = useState(false);
    const { t } = useTranslation();
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [sortId, setSortId] = useState([]);
    const [courses, setCourses] = useState([]);
    const [allsubjects, setAllSubjects] = useState([]);
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [selectedSubjectId, setSelectedSubjectId] = useState("");
    const [showAddCourseModal, setShowAddCourseModal] = useState(false);
    const [addCourseId, setAddCourseId] = useState("");
    const [addSubjects, setAddSubjects] = useState([]);
    const [addSelectedSubjectId, setAddSelectedSubjectId] = useState("");
    const [userEducationals, setUserEducationals] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const params = useParams();

    const navigate = useNavigate();

    const getAuthHeaders = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    });

    const fetchSubjectsByCourse = async (courseId, target = "main") => {
        if (!courseId) {
            if (target === "main") {
                setSubjects([]);
            } else {
                setAddSubjects([]);
            }
            return;
        }

        try {
            if (target === "main") {
                setSubjectLoading(true);
                setSubjects([]);
            } else {
                setAddSubjects([]);
            }

            const url = "https://api.heryerdeingilizce.com/api/admin/SubjectManager/GetListByCourse";
            const res = await axios({
                method: 'GET',
                url: url,
                headers: getAuthHeaders(),
                params: {
                    id: courseId
                }
            });

            if (res.status === 200) {
                if (res.data['success']) {
                    const activeSubjects = (res.data?.data || []).filter((item) => item?.isActive);
                    if (target === "main") {
                        setSubjects(activeSubjects);
                    } else {
                        setAddSubjects(activeSubjects);
                    }
                }
                else {
                    setMsg(res.data['message']);
                }
            }
            else {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
        }
        catch (err) {
            setMsg(err?.message || err);
        } finally {
            if (target === "main") {
                setSubjectLoading(false);
            }
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        let CourseId = 0;
        let SubjectId = 0;

        courses.forEach((item) => {
            if (item['id'] === parseInt(selectedCourseId)) {
                CourseId = item.sortId;
            }
        });

        allsubjects.forEach((item) => {
            if (item['id'] === parseInt(selectedSubjectId)) {
                SubjectId = item['sortId'];
            }
        });

        try {
            let url = "https://api.heryerdeingilizce.com/api/admin/User/UpdateEducational";
            await axios({
                method: 'PUT',
                url: url,
                data: {
                    userId: params['id'],
                    courseId: parseInt(CourseId),
                    subjectId: parseInt(SubjectId),
                    contentId: 1
                },
                headers: getAuthHeaders()
            }).then(res => {
                if (res.status === 200) {

                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err);
        }
    }

    const onChange = async (e) => {
        const value = e.target.value;
        setSelectedSubjectId(value);

        try {
            let url = "https://api.heryerdeingilizce.com/api/admin/ContentManager/GetListBySubject";

            await axios({
                method: 'GET',
                url: url,
                headers: getAuthHeaders(),
                params: {
                    subjectId: value
                }
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        if (res.data['data'].length !== 0) {
                            setSortId((res.data['data'][res.data['data'].length - 1]['sortId']) + 1)
                        }
                        else {
                            setSortId(1)
                        }
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);
        }

    }

    const realonChange = async (e) => {
        const courseId = e.target.value;
        setSelectedCourseId(courseId);
        setSelectedSubjectId("");
        await fetchSubjectsByCourse(courseId, "main");
    }

    const GetCourses = async () => {
        try {
            await GeneralRequestHelper("/api/admin/CourseManager/GetCourses", "get", "", user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        console.log(res)
                        const activeCourses = (res.data?.data || [])
                            .filter((item) => item?.isDeleted === false && item?.isActive)
                            .map((item) => ({
                                id: item.id,
                                courseName: item.courseName,
                                courseDesc: item.courseDesc,
                                sortId: item.sortId
                            }));

                        setCourses(activeCourses);
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    }

    const GetAllSubjects = async () => {
        try {
            await GeneralRequestHelper("/api/admin/SubjectManager/GetList", "get", "", user.token).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        const activeSubjects = (res.data?.data || [])
                            .filter((item) => item?.isDeleted === false && item?.isActive)
                            .map((item) => ({
                                id: item.id,
                                subjectName: item.subjectName,
                                sortId: item.sortId
                            }));

                        setAllSubjects(activeSubjects);
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    }

    const GetUserById = async () => {
        try {
            const res = await axios({
                method: 'GET',
                url: "https://api.heryerdeingilizce.com/api/admin/User/GetUserById",
                headers: getAuthHeaders(),
                params: {
                    userId: params['id']
                }
            });

            if (res.status === 200 && res.data?.success) {
                const data = res.data?.data || {};
                const educationals = data?.educationals || [];
                setUserInfo(data?.user || null);
                setUserEducationals(educationals);

                if (educationals.length === 1) {
                    const firstEducational = educationals[0];
                    setSelectedCourseId(String(firstEducational.courseId || ""));
                    setSelectedSubjectId(String(firstEducational.subjectId || ""));
                    await fetchSubjectsByCourse(firstEducational.courseId, "main");
                }
            } else {
                setMsg(res.data?.message || "Kullanıcı bilgisi alınamadı.");
            }
        } catch (err) {
            setMsg(err?.message || "Kullanıcı bilgisi alınamadı.");
        }
    };

    const handleOpenAddCourseModal = () => {
        setAddCourseId("");
        setAddSelectedSubjectId("");
        setAddSubjects([]);
        setShowAddCourseModal(true);
    };

    const handleAddCourseChange = async (e) => {
        const courseId = e.target.value;
        setAddCourseId(courseId);
        setAddSelectedSubjectId("");
        await fetchSubjectsByCourse(courseId, "modal");
    };

    const toPlainOptionLabel = (str = "") =>
        str
            .replace(/<\s*sup\s*>/gi, "")   // <sup>
            .replace(/<\s*\/\s*sup\s*>/gi, ""); // </sup>

    const handleAddUserCourse = async () => {
        if (!addCourseId) {
            Swal.fire({
                title: "Lütfen kurs seçiniz.",
                icon: "warning",
                confirmButtonText: "Tamam"
            });
            return;
        }

        try {
            const res = await axios({
                method: 'POST',
                url: "https://api.heryerdeingilizce.com/api/admin/User/AddUserCourse",
                headers: getAuthHeaders(),
                data: {
                    userId: parseInt(params['id']),
                    courseId: parseInt(addCourseId)
                }
            });

            if (res.status === 200 && res.data?.success) {
                Swal.fire({
                    title: "Kurs başarıyla eklendi!",
                    icon: "success",
                    confirmButtonText: "Tamam",
                    timer: 2500
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire({
                    title: res.data?.message || "Kurs eklenemedi.",
                    icon: "error",
                    confirmButtonText: "Tamam"
                });
            }
        } catch (err) {
            Swal.fire({
                title: err?.message || "Kurs eklenemedi.",
                icon: "error",
                confirmButtonText: "Tamam"
            });
        }
    };

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await Promise.all([
                GetCourses(),
                GetAllSubjects(),
                GetUserById()
            ]);
            setLoading(false);
        };

        init();
    }, []);

    return (
        <div>
            {userEducationals.length === 0 && (
                <div className="alert alert-warning d-flex justify-content-between align-items-center flex-wrap gap-2" role="alert">

                    <div>
                        <strong>Uyarı:</strong> Üyenin henüz hiç kursu yok. Eklemek için tıklayın.
                    </div>
                    <button
                        type="button"
                        className="btn btn-warning"
                        onClick={handleOpenAddCourseModal}
                    >
                        Kurs Ekle
                    </button>
                </div>
            )}

            {userEducationals.length === 1 && (
                <div className="alert alert-info" role="alert">
                    <strong>Bilgi:</strong> Üyenin 1 aktif eğitim bilgisi vardır.
                    <br /><br />
                    <button
                        type="button"
                        className="btn btn-warning"
                        onClick={handleOpenAddCourseModal}
                    >
                        Yeni Kurs Ekle
                    </button>
                </div>
            )}
            {userEducationals.length > 1 && (
                <div className="alert alert-info" role="alert">
                    <strong>Bilgi:</strong> Üyenin {userEducationals.length} aktif eğitim bilgisi vardır.
                    <br />        <br />
                    <button
                        type="button"
                        className="btn btn-warning"
                        onClick={handleOpenAddCourseModal}
                    >
                        Yeni Kurs Ekle
                    </button>
                </div>
            )}
            <div style={{ textAlign: "center" }}>
                <h1>Eğitim bilgisi güncelle</h1>
            </div>

            {userInfo && (
                <div className="mb-3">
                    <h5>Kullanıcı: {userInfo?.fullName} - {userInfo?.username}</h5>
                </div>
            )}

            <h4>{msg}</h4>

            {loading && <div className="text-center my-4"><h5>Veriler yükleniyor...</h5></div>}

            {/* Eski tekli form yerine her bir elemanı map ile dönüp yeni formu basıyoruz */}
            {!loading && userEducationals && userEducationals.map((edu, index) => (
                <SingleEducationalForm
                    key={edu.id || index}
                    educational={edu}
                    courses={courses}
                    allsubjects={allsubjects}
                    userId={params['id']}
                    userToken={user.token}
                    t={t}
                    toPlainOptionLabel={toPlainOptionLabel}
                />
            ))}

            {showAddCourseModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                        tabIndex="-1"
                        role="dialog"
                    >
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Kurs Ekle</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowAddCourseModal(false)}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">{t("selectCourse")}</label>
                                        <select
                                            className="form-select"
                                            style={{ textOverflow: "ellipsis", maxWidth: "100%" }}
                                            value={addCourseId}
                                            onChange={handleAddCourseChange}
                                        >
                                            <option value="">{t("selectCourse")}</option>
                                            {courses.map((course) => {
                                                const fullText = toPlainOptionLabel(`${course.courseName} - ${course.courseDesc}`);
                                                const truncatedText = fullText.length > 55 ? fullText.substring(0, 55) + "..." : fullText;

                                                return (
                                                    <option key={course.id} value={course.id} title={fullText}>
                                                        {truncatedText}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">{t("selectSubject")}</label>
                                        <select
                                            className="form-select"
                                            style={{ textOverflow: "ellipsis", maxWidth: "100%" }}
                                            value={addSelectedSubjectId}
                                            onChange={(e) => setAddSelectedSubjectId(e.target.value)}
                                            disabled={!addCourseId}
                                        >
                                            <option value="">{t("selectSubject")}</option>
                                            {addSubjects.map((subject) => {
                                                const fullText = toPlainOptionLabel(`${subject.subjectName} - ${subject.subjectDesc}`);
                                                const truncatedText = fullText.length > 55 ? fullText.substring(0, 55) + "..." : fullText;

                                                return (
                                                    <option key={subject.id} value={subject.id} title={fullText}>
                                                        {truncatedText}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>

                                    <small className="text-muted">
                                        Kurs ekleme işlemi seçilen courseId ile yapılacaktır.
                                    </small>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setShowAddCourseModal(false)}
                                    >
                                        Kapat
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={handleAddUserCourse}
                                    >
                                        Kursu Ekle
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
export default AdminEditUserEducational;